import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/utils/api';

export function useAnnotations(emailId, type = null) {
  return useQuery({
    queryKey: ['annotations', emailId, type],
    queryFn: async () => {
      const params = type ? { type } : {};
      const response = await api.get(`/emails/${emailId}/annotations`, { params });
      return response.data.data;
    },
    enabled: !!emailId
  });
}

export function useAddAnnotation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ emailId, type, content, source, metadata }) => {
      const response = await api.post(`/emails/${emailId}/annotations`, {
        type,
        content,
        source,
        metadata
      });
      return response.data.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['annotations', variables.emailId] });
    }
  });
}

export function useUpdateAnnotation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ annotationId, content, metadata }) => {
      const response = await api.put(`/annotations/${annotationId}`, {
        content,
        metadata
      });
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['annotations'] });
    }
  });
}

export function useRemoveAnnotation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (annotationId) => {
      await api.delete(`/annotations/${annotationId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['annotations'] });
    }
  });
}

export function useAllTags() {
  return useQuery({
    queryKey: ['annotations', 'tags'],
    queryFn: async () => {
      const response = await api.get('/annotations/tags');
      return response.data.data;
    }
  });
}
